function setRecoverySnackbarSuccess({ state }) {
  state.merge('login.recovery.snackbar', { show: true, success: true })
  state.merge('login.recovery.forgot.email', { value: '', isTouched: false })
}

export default setRecoverySnackbarSuccess



// WEBPACK FOOTER //
// ./src/modules/login/actions/setRecoverySnackbarSuccess.js